var interfaces;
(function (interfaces) {
    ;
})(interfaces || (interfaces = {}));
export { interfaces };
